module.exports = __webpack_public_path__ + "c309df0efd5e06b8d9c7d548b0c36e43.png";